import layoutActions from "actions/layout";
import modalActions from "actions/modal";
import profileActions from "actions/profile";
import { connect } from "helpers/redux";

export default function (Component) {
    const mapState = (state) => ({
        organization: state.profile.organization,
        profile: state.profile.profile,
        sidebarOpened: state.layout.sidebarOpened,
        links: state.layout.links,
        roles: state.profile.roles,
        jivoChatScriptUrl: state.configs.jivoChatScriptUrl,
    });

    const mapDispatch = (dispatch) => ({
        toggleFullscreen: () => dispatch(layoutActions.toggleFullscreen()),
        toggleSidebar: (params) => dispatch(layoutActions.toggleSidebar(params)),
        modal: (params) => dispatch(modalActions.open(params)),
        closeModal: () => dispatch(modalActions.close()),
        getOrg: () => dispatch(profileActions.getOrg()),
    });

    return connect(mapState, mapDispatch)(Component);
}
